import { render, staticRenderFns } from "./stu-service.vue?vue&type=template&id=67190e00&scoped=true"
import script from "./stu-service.vue?vue&type=script&lang=js"
export * from "./stu-service.vue?vue&type=script&lang=js"
import style0 from "./stu-service.vue?vue&type=style&index=0&id=67190e00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67190e00",
  null
  
)

export default component.exports